import { OverflowDisplayTooltip } from "../../OverflowDisplayTooltip";

interface FileTreeLabelProps {
  label: string;
  path: string;
  readOnly: boolean;
}

export const FileTreeLabel = ({
  label,
  path,
  readOnly,
}: FileTreeLabelProps) =>
  readOnly ? (
    <span className="truncate text-[13px]" title={path}>
      {label}
    </span>
  ) : (
    <OverflowDisplayTooltip content={path} side="top">
      <span className="truncate text-[13px]">{label}</span>
    </OverflowDisplayTooltip>
  );
